'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCommentMessage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reduce = require('transmute/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _immutable = require('immutable');

var _CommentMessage = require('../records/CommentMessage');

var _CommentMessage2 = _interopRequireDefault(_CommentMessage);

var _timestamps = require('../../lib/timestamps');

var _Status = require('../../common-message-format/records/Status');

var _Status2 = _interopRequireDefault(_Status);

var _attachmentTypes = require('../constants/attachmentTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCommentMessage = exports.buildCommentMessage = function buildCommentMessage() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var status = (0, _Status2.default)((0, _getIn2.default)(['status'], attrs));
  var _attrs$attachments = attrs.attachments,
      attachments = _attrs$attachments === undefined ? [] : _attrs$attachments;

  var attachmentsList = (0, _reduce2.default)((0, _immutable.List)(), function (attachmentList, attachment) {
    var attachmentType = attachment[_attachmentTypes.ATTACHMENT_TYPE_ID];
    return attachmentType === _attachmentTypes.MENTIONS ? attachmentList.push((0, _immutable.fromJS)(attachment)) : attachmentList;
  }, attachments);
  return (0, _CommentMessage2.default)((0, _immutable.fromJS)(_extends({}, attrs, {
    status: status,
    attachments: attachmentsList,
    timestamp: (0, _getIn2.default)(['timestamp'], attrs) || (0, _timestamps.generateUniqueClientTimestamp)('buildCommentMessage-timestamp')
  })));
};